import React from 'react';
import {connect} from "react-redux";
import Home from "./Home";
import Cases from "./Cases"
import ModalComponent from "../../../components/Modal";

class UserPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabName: this.props.history.location.state && this.props.history.location.state.tabName === "case_summary" ? "case_summary": "patients",
            updatePopupShow:false,
        }
    }


    componentDidMount() {
        const isUpdatePopupSeen = localStorage.getItem('isUpdatePopupSeen');
        this.setState({updatePopupShow:!isUpdatePopupSeen})
    }

    componentWillUnmount() {

    }

    changeTab = (tabName) => {
        this.setState({tabName: tabName})
    }

    render() {
        return (
            <div>
                {
                    this.state.tabName === 'patients' && <Home tabName={this.state.tabName} changeTab={this.changeTab} props={this.props} />
                }
                {
                    this.state.tabName === 'case_summary' && <Cases tabName={this.state.tabName} changeTab={this.changeTab} props={this.props} />
                }
                {
                    this.state.updatePopupShow &&
                    <ModalComponent
                        modalHeaderStyle="modalHeaderDefault"
                        headerTitle="NEW LOOK ALERT!"
                        modalTitle="subcaseModalTitle modalTitle"
                        infoModal={true}
                        modalBody={
                            <div>
                                We have revamped the look and feel of our app to enhance your experience. The process to book a case is still the same.
                                If you have any questions or concerns, please reach out to info@kerenor.ca
                            </div>
                        }
                        cancelButtonName='Close'
                        dialogClassName={"subcase__modal__dialog"}
                        show={this.state.updatePopupShow}
                        handleClose={() => {
                            localStorage.setItem('isUpdatePopupSeen','true')
                            this.setState({updatePopupShow:false})
                            }
                        }
                    />
                }
            </div>

        )
    }
}

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => {
    return {

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPage);



// WEBPACK FOOTER //
// ./src/containers/Layouts/User/UserPage.js